import { RESET_STATE } from 'store/global/actions';
import { LOAN_APPPLICATION_NON_BORROWERS_ACTION_TYPE } from 'store/loanApplications/actions';

const initialState = null;

const loanApplicationNonBorrowersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_APPPLICATION_NON_BORROWERS_ACTION_TYPE.GET_NON_BORROWERS_TABLE_DATA: {
      return payload || initialState;
    }

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default loanApplicationNonBorrowersReducer;
